export default __webpack_public_path__ + "static/Greenbay-e8b15762dadf169e1604052fdd63f654.png";